import React from "react";
import { useForm } from "react-hook-form";

const AddReportListForm = ({ close, refreshTable }) => {
  const { handleSubmit, register } = useForm();

  const onSubmit = (data) => {
  };

  return (
    <div className="mt-2">
      <form className="py-5 bg-white" onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
          <div className="row">
            <div className="col-6 mb-4">
              <label htmlFor="reportName" className="form-label fw-bold">
                Report Name
              </label>
              <input
                id="reportName"
                name="reportName"
                type="text"
                className="form-control"
                {...register("reportName", { required: true })}
              />
            </div>

            <div className="col-6 mb-4">
              <label htmlFor="reportLink" className="form-label fw-bold">
                Report Link
              </label>
              <input
                id="reportLink"
                name="reportLink"
                type="text"
                className="form-control"
                {...register("reportLink", { required: true })}
              />
            </div>

            <div className="col-12 mb-4">
              <label htmlFor="reportDescription" className="form-label fw-bold">
                Report Description
              </label>
              <textarea
                id="reportDescription"
                name="reportDescription"
                rows={3}
                className="form-control"
                {...register("reportDescription", { required: true })}
              />
            </div>

            <div className="col-6 mb-4">
              <label htmlFor="reportOrder" className="form-label fw-bold">
                Report Order
              </label>
              <input
                id="reportOrder"
                name="reportOrder"
                type="text"
                className="form-control"
                {...register("reportOrder", { required: true })}
              />
            </div>

            <div className="col-6 mb-4">
              <label className="form-label fw-bold">Is Active</label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    id="isActiveYes"
                    name="isActive"
                    type="radio"
                    value="Yes"
                    className="form-check-input"
                    {...register("is_active", { required: true })}
                  />
                  <label htmlFor="isActiveYes" className="form-check-label">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    id="isActiveNo"
                    name="isActive"
                    type="radio"
                    value="No"
                    className="form-check-input"
                    {...register("is_active", { required: true })}
                  />
                  <label htmlFor="isActiveNo" className="form-check-label">
                    No
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-5">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => close()}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary text-white">
            Add Item
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddReportListForm;
